import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { clearChunkReloadFlag } from 'utils/lazyImport';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import 'dayjs/locale/pt';

import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import ErrorBoundary from 'components/shared/ErrorBoundary';
import { AuthProvider } from 'contexts/AuthContext';
import { ShellConfigProvider } from 'contexts/ShellConfigContext';
import buildMenu from 'menu-items';

const DATE_LOCALES = { es: 'es', en: 'en', pt: 'pt' };

export default function App() {
  const { i18n } = useTranslation();
  const adapterLocale = DATE_LOCALES[i18n.language] ?? 'es';

  useEffect(() => {
    clearChunkReloadFlag();
  }, []);

  const shell = useMemo(
    () => ({
      homePath: '/',
      buildMenu,
      HeaderExtras: null,
      Banner: null
    }),
    []
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      <ThemeCustomization>
        <AuthProvider>
          <ShellConfigProvider value={shell}>
            <ErrorBoundary>
              <ScrollTop>
                <RouterProvider router={router} />
              </ScrollTop>
            </ErrorBoundary>
          </ShellConfigProvider>
        </AuthProvider>
      </ThemeCustomization>
    </LocalizationProvider>
  );
}
